$(() => {
    if ($('.post-body').height() > window.innerWidth) {
        $('.bottom-back-url-wrap').show();
    }
});
